export default {
  getEmployees(state) {
    return state.employees;
  },

  lastTimeStamp(state) {
    const lastStamp = state.lastFetch;
    if (!lastStamp) {
      return true;
    }
    const currentStamp = new Date().getTime();
    return (currentStamp - lastStamp) / 1000 > 60;
  },
};
